export class Movement {
  constructor(dx, dy) {
    this.dx = dx;
    this.dy = dy;
  }
}
